module.exports = __webpack_public_path__ + "img/btn_color.7e0334a5.svg";